import { Template, Component, Attribute } from '@scoutgg/ftw/source/lib';
import { prompt } from '@scoutgg/ftw/source/services/modal';
import { Match, Event } from '../../models';
import camelCase from 'camelcase';
import template from './race-results.jade';
import sources from '../../../helpers/sources';
import '../status';
import '../match-times';
import '../lineups';
import getState from '../../services/create-event';
import notify from '@scoutgg/ftw/source/services/notification';
import emitter from '@scoutgg/ftw/source/services/emitter';
import normalize from '../../../helpers/normalize';

import '@scoutgg/ftw/source/atoms/form-control/form-control';
const rankTypes = [
  'rank',
  'round1_rank',
  'round2_rank',
  'time_rank',
  'loop_rank',
  'checkpoint_rank',
  'split_rank',
  'downhill_rank',
  'downhill_speed_rank',
  'downhill_split_rank',
  'combined_slalom_rank',
  'combined_downhill_rank',
  'combined_downhill_speed_rank',
  'combined_rank',
  'relay_team_rank',
  'relay_time_rank',
  'sprint_prolog_rank',
  'sprint_quarter_rank',
  'sprint_semi_rank',
  'sprint_final_rank',
  'team_sprint_semifinal_rank',
  'team_sprint_semifinal_time_rank',
  'team_sprint_final_rank',
  'team_sprint_final_time_rank',
  'mass_start_rank',
  'mass_start_men_split1_rank',
  'mass_start_men_split2_rank',
  'mass_start_men_split3_rank',
  'mass_start_men_split4_rank',
  'mass_start_women_split1_rank',
  'mass_start_women_split2_rank',
  'mixed_relay_rank',
  'mixed_relay_team_rank',
  'sprint_split1_rank',
  'sprint_split2_rank',
  'pursuit_split1_a_rank',
  'pursuit_split2_a_rank',
  'pursuit_split1_b_rank',
  'pursuit_split2_b_rank',
  'individual_split1_rank',
  'individual_split2_rank',
  'individual_split3_rank',
  'individual_split4_rank',
  'single_mixed_rank',
  'single_mixed_team_rank',
  'relay_rank',
  'mass_start_split1_rank',
  'mass_start_split2_rank',
  'mass_start_split3_rank',
  'mass_start_split4_rank',
  'shooting_relay',
  'shooting_other',
  'starting_rank',
];

const unrankable = ['ctor', 'manager', 'rider', 'coach'];

const eventTypes = {
  cycling: [
    'rank',
    'yellow_shirt',
    'green_shirt',
    'climber_shirt',
    'youth_shirt',
    'aggressive',
    'auxiliary1',
    'auxiliary2',
    'auxiliary3',
    'ping',
  ],
  cc_ski: ['rank', 'split_rank'],
  cc_ski_sprint: [
    'sprint_prolog_rank',
    'sprint_quarter_rank',
    'sprint_semi_rank',
    'sprint_final_rank',
  ],
  cc_ski_team_sprint: [
    'team_sprint_semifinal_rank',
    'team_sprint_semifinal_time_rank',
    'team_sprint_final_rank',
    'team_sprint_final_time_rank',
  ],
  cc_ski_relay: ['relay_team_rank'],
  cc_ski_relay_stage: ['relay_time_rank'],
  cc_ski_mass_start_men: [
    'mass_start_rank',
    'mass_start_men_split1_rank',
    'mass_start_men_split2_rank',
    'mass_start_men_split3_rank',
    'mass_start_men_split4_rank',
  ],
  cc_ski_mass_start_women: [
    'mass_start_rank',
    'mass_start_women_split1_rank',
    'mass_start_women_split2_rank',
  ],
  cc_ski_with_shirt: ['rank', 'winner_shirt'],
  ski_jump: [
    'rank',
    'round1_rank',
    'round2_rank',
    'longest_jump',
    'hill_record',
  ],
  biathlon: ['rank'],
  biathlon_mixed_relay: ['mixed_relay_team_rank'],
  biathlon_mixed_relay_stage: ['mixed_relay_rank', 'shooting_relay'],
  biathlon_sprint: [
    'rank',
    'sprint_split1_rank',
    'sprint_split2_rank',
    'shooting_other',
  ],
  biathlon_pursuit: [
    'rank',
    'pursuit_split1_a_rank',
    'pursuit_split2_a_rank',
    'pursuit_split1_b_rank',
    'pursuit_split2_b_rank',
    'shooting_other',
  ],
  biathlon_individual: [
    'rank',
    'individual_split1_rank',
    'individual_split2_rank',
    'individual_split3_rank',
    'individual_split4_rank',
    'shooting_other',
  ],
  biathlon_single_mixed: ['single_mixed_team_rank'],
  biathlon_single_mixed_stage: ['single_mixed_rank', 'shooting_other'],
  biathlon_relay: ['relay_team_rank'],
  biathlon_relay_stage: ['relay_rank', 'shooting_relay'],
  biathlon_mass_start: [
    'rank',
    'mass_start_split1_rank',
    'mass_start_split2_rank',
    'mass_start_split3_rank',
    'mass_start_split4_rank',
    'shooting_other',
  ],
  alpine: ['rank', 'split_rank'],
  alpine_downhill: [
    'downhill_rank',
    'downhill_speed_rank',
    'downhill_split_rank',
  ],
  alpine_combined: [
    'combined_rank',
    'combined_downhill_rank',
    'combined_downhill_speed_rank',
    'combined_slalom_rank',
  ],
  formula_one_qualifier: ['rank'],
  formula_one: [
    'rank',
    'starting_rank',
    'fastest_lap',
    'driver_of_the_day',
    'fastest_pit_stop',
  ],
  formula_one_sprint: [
    'rank',
    'starting_rank',
    'fastest_lap',
    'driver_of_the_day',
    'fastest_pit_stop',
  ],
  eurovision: ['jury_rank'],
};

const eventNames = {
  rank: 'Rank',
  round1_rank: 'R1',
  round2_rank: 'R2',
  yellow_shirt: 'Yellow Shirt',
  green_shirt: 'Green Shirt',
  climber_shirt: 'Polka Shirt',
  youth_shirt: 'Youth Shirt',
  winner_shirt: 'Winner Shirt',
  aggressive: 'Most Aggressive',
  auxiliary1: 'Auxiliary 1',
  auxiliary2: 'Auxiliary 2',
  auxiliary3: 'Auxiliary 3',
  longest_jump: 'Longest',
  hill_record: 'Record',
  time_rank: 'Time',
  loop_rank: 'Shooting',
  split_rank: 'Split',
  combined_rank: 'Rank',
  combined_downhill_rank: 'Downhill Rank',
  combined_downhill_speed_rank: 'Downhill Speed Rank',
  downhill_rank: 'Rank',
  downhill_speed_rank: 'Downhill Speed Rank',
  downhill_split_rank: 'Split',
  combined_slalom_rank: 'Slalom',
  sprint_prolog_rank: 'Sprint Prolog Rank',
  sprint_quarter_rank: 'Sprint Quarter Rank',
  sprint_semi_rank: 'Sprint Semi Final Rank',
  sprint_final_rank: 'Sprint Final Rank',
  team_sprint_semifinal_time_rank: 'Team Sprint Semi Final Time Rank',
  team_sprint_semifinal_rank: 'Team Sprint Semi Final Rank',
  team_sprint_final_rank: 'Team Sprint Final Rank',
  team_sprint_final_time_rank: 'Team Sprint Final Time Rank',
  relay_time_rank: 'Relay Time Rank',
  relay_team_rank: 'Relay Team Rank',
  mass_start_rank: 'Mass Start Rank',
  mass_start_women_split1_rank: 'First Split Rank (Women)',
  mass_start_women_split2_rank: 'Second Split Rank (Women)',

  mass_start_men_split1_rank: 'First Split Rank (Men)',
  mass_start_men_split2_rank: 'Second Split Rank (Men)',
  mass_start_men_split3_rank: 'Third Split Rank (Men)',
  mass_start_men_split4_rank: 'Fourth Split Rank (Men)',

  mixed_relay_rank: 'Mixed Relay Rank',
  mixed_relay_team_rank: 'Mixed Relay Team Rank',
  sprint_split1_rank: 'Sprint Split Rank',
  sprint_split2_rank: 'Sprint Split Rank',
  pursuit_split1_a_rank: 'Pursuit First Split',
  pursuit_split2_a_rank: 'Pursuit Second Split',
  pursuit_split1_b_rank: 'Pursuit Third Split',
  pursuit_split2_b_rank: 'Pursuit Fourth Split',
  individual_split1_rank: 'Individual First Split',
  individual_split2_rank: 'Individual Second Split',
  individual_split3_rank: 'Individual Third Split',
  individual_split4_rank: 'Individual Fourth Split',
  single_mixed_rank: 'Single Mixed Rank',
  single_mixed_team_rank: 'Single Mixed Team Rank',
  relay_rank: 'Relay Rank',
  mass_start_split1_rank: 'Mass Start First Split',
  mass_start_split2_rank: 'Mass Start Second Split',
  mass_start_split3_rank: 'Mass Start Third Split',
  mass_start_split4_rank: 'Mass Start Fourth Split',
  shooting_relay: 'Hit Targets',
  shooting_other: 'Hit Targets',

  starting_rank: 'Start Rank',
  fastest_lap: 'Fastest Lap',
  driver_of_the_day: 'Driver of the Day',
  fastest_pit_stop: 'Fastest Pit Stop',

  jury_rank: 'Jury Rank',
  ping: 'Ping',
};

@Component('sporty')
@Template(template)
@Attribute('match', Match)
@Attribute('edit-mode', Boolean)
@Attribute('search', String)
@Attribute('event-type', String)
@Attribute('batch', Number)
@Attribute('position-override', Number)
@Attribute('hits', Number)
@Attribute('selected', Boolean)
export default class RaceResults extends HTMLElement {
  attached() {
    this.update(this.match.load()).then((res) => {
      this.players = res[0].match.teams.flatMap((t) => t.players);
      if (!this.events) this.events = [];
      this.render();
    });
    this.eventType = this.eventTypes[0];
    this.state.listen(this, true);
    this.dropdownOpen = false;
  }

  reset() {
    this.state.reset();
  }

  matchChange() {
    this.update(this.match.load());
    this.state.listen(this, true);
  }

  setHits(val) {
    this.hits = val;
  }

  saveStats() {
    var lineups = this.match.lineups.map((lineup) => {
      return {
        _id: lineup._id,
        match: lineup.matchId,
        player: lineup.playerId,
        team: lineup.teamId,
        stats: lineup.stats,
        status: lineup.status,
        duration: lineup.duration,
        trainer: lineup.trainer,
        rider: lineup.rider,
      };
    });

    this.checkDuplicateRanks()
      .then(() => this.match.post('lineups', { lineups }))
      .then(() => {
        notify('Stats saved', { level: 'success', timeout: 3000 });
        this.state.reload(true);
        emitter.emit('match-updated');
        this.editMode = false;
        this.render();
      });
  }

  checkDuplicateRanks() {
    var checked = 0;
    var batch = 0;
    const duplicate = this.match.lineups
      .filter((l) => l.stats && l.stats.rank)
      .filter((l) => !~unrankable.indexOf(l.player.position))
      .sort((a, b) => {
        if ((a.batch || b.batch) && a.batch !== b.batch) {
          return (a.batch || 0) - (b.batch || 0);
        }
        return a.stats.rank - b.stats.rank;
      })
      .find((l) => {
        if (l.batch && l.batch !== batch) {
          batch = l.batch;
          checked = 0;
        }
        if (l.stats.rank !== checked) {
          checked = l.stats.rank;
          return false;
        } else {
          return true;
        }
      });
    if (duplicate) {
      return prompt(
        `
        There are several players with rank ${duplicate.stats.rank}.
        Are you sure everything is in order?
      `,
        { type: 'yesno' },
      );
    } else {
      return Promise.resolve();
    }
  }

  canScrapeLineups(source) {
    var s = sources[source.source];
    return s && s.lineups;
  }

  scrapeLineups(source) {
    source
      .post('scrape')
      .then(() => {
        notify('Lineups gathered', { level: 'success', timeout: 5000 });
        this.state.reload(true);
      })
      .catch((err) => {
        console.error(err.stack);
        notify(err.message, { level: 'danger', timeout: 10000 });
      });
  }

  get canComputeAggregate() {
    const { sport, matchType, difficulty } = this.match || {};
    return sport === 'cc_ski' && matchType === 'heat' && (difficulty || 0) < 3;
  }
  get hasShootingEvents() {
    return this.match.sport === 'biathlon';
  }
  get hasJuryEvents() {
    return this.match.sport === 'eurovision';
  }
  computeAggregate() {
    if (this.match.$isSubmitting) return;
    this.match
      .post('aggregate')
      .then(() => {
        notify('Stats computed', { level: 'success', timeout: 5000 });
      })
      .catch((err) => {
        notify(err.message, { level: 'danger', timeout: 10000 });
      })
      .then(() => this.render());
  }

  sendFeeds() {
    if (this.match.$isSubmitting) return;
    this.match
      .post('send-feeds', { forceCalculations: true })
      .then(() => {
        notify('Events sent', { level: 'success', timeout: 5000 });
      })
      .catch((err) => {
        notify(err.message, { level: 'danger', timeout: 10000 });
      })
      .then(() => this.render());
    this.render();
  }

  saveSettings() {
    if (this.match.$isSubmitting) return;
    this.match
      .save({
        match: {
          difficulty: this.match.difficulty,
          sprints: this.match.sprints,
        },
      })
      .then(() => {
        notify('Match updated', { level: 'success', timeout: 5000 });
      })
      .catch((err) => {
        notify(err.message, { level: 'danger', timeout: 10000 });
      })
      .then(() => this.render());
    this.render();
  }

  receiver(lineup, val) {
    const event = this.events.find(
      (e) =>
        e.name && e.name.split('_')[0] === lineup.lastName && e.minute === val,
    );
    return (event && event.player && event.player.lastName) || '';
  }

  findAndDestroy(player, val) {
    const event = this.events.find(
      (e) =>
        e.name && e.name.split('_')[0] === player.lastName && e.minute === val,
    );
    this.destroy(event);
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
    this.render();
  }
  setJuryRank(val) {
    this.juryRank = val;
    this.render();
  }
  isSelectedRank(val) {
    return this.juryRank === val ? 'selected' : '';
  }
  setActiveLineup(player) {
    this.activeLineup = player;
    this.render();
  }
  isGiver(player) {
    if (!this.activeLineup) return false;
    return player.lastName === this.activeLineup.lastName;
  }
  async addJuryRank(lineup) {
    if (this.isSubmittingRank) return;
    if (!this.activeLineup) return;
    const eventType = this.eventType || 'rank';
    const name = this.activeLineup.lastName + '_juryRank' + this.juryRank;
    const minute = this.juryRank;
    if (this.activeLineup.lastName === lineup.player.lastName) return;
    if (!lineup) return;
    const event = {
      second: 0,
      minute: minute,
      name: name,
      match: this.match._id,
      team: lineup.team._id,
      player: lineup.player._id,
    };
    if (eventType === 'ping') {
      delete event.player;
      delete event.team;
    }
    const existingEventList = this.events.filter(
      (e) =>
        e.name &&
        e.name.split('_')[0] === this.activeLineup.lastName &&
        e.minute === this.juryRank,
    );
    for (const existingEvent of existingEventList) {
      await existingEvent.destroy();
    }
    this.match
      .post('events', {
        event: event,
        skipCalculations: true,
      })
      .catch((err) => console.error(err))
      .then(() => {
        this.events.push(Event.create(event));
        this.isSubmittingRank = false;
        lineup.$isSubmitting = false;
        this.state.reload(true);
      });
  }
  addRank(lineup) {
    if (this.isSubmittingRank) return;
    const eventType = this.eventType || 'rank';
    this.search = '';
    if (!lineup.stats) lineup.stats = {};
    const isRank = rankTypes.includes(eventType);
    if (isRank) {
      var rank = this.positionOverride || this.nextPosition;
      this.positionOverride = null;
      lineup.stats[camelCase(eventType)] = rank;
    }
    lineup.$isSubmitting = true;
    this.isSubmittingRank = true;
    var name;
    var minute = (this.batch || 1) * 1000 + (rank || 0);
    const type = this.match.matchType || 'normal';
    const difficulty = this.match.difficulty || 0;
    if (!isRank) {
      name = eventType;
      minute = 100001;
    } else if (['cycling', 'cycling_vm'].includes(this.match.sport)) {
      name =
        type === 'sprint'
          ? `sprint_rank${rank}`
          : type === 'climb'
            ? `climb${difficulty}_rank${rank}`
            : type === 'checkpoint'
              ? `checkpoint_rank${rank}`
              : type === 'team'
                ? `team_tempo_rank${rank}`
                : type === 'normal' && rank < 20
                  ? `rank${rank}`
                  : type === 'normal' && rank < 40
                    ? 'top39'
                    : type === 'normal' && rank < 100
                      ? 'top99'
                      : 'finished';
    } else if (this.match.sport === 'cc_ski') {
      switch (type) {
        case 'sprint':
          if (rank < 7) {
            name = `${eventType}${rank}`;
          } else if (rank < 11 && /prolog/.test(eventType)) {
            name = 'prolog_top10';
          } else if (rank < 21 && /prolog/.test(eventType)) {
            name = 'prolog_top20';
          } else if (rank < 31 && /prolog/.test(eventType)) {
            name = 'prolog_top30';
          } else {
            name = `${eventType}${rank}`;
          }
          minute = rank;
          break;
        case 'team_sprint':
          name = `${eventType}${rank}`;
          minute = rank;
          break;
        default:
          if (rank > 29 && !/split|time/.test(eventType)) {
            name = 'finished' + ' ' + eventType;
          } else if (rank > 19 && !/split|time/.test(eventType)) {
            name = 'top29' + ' ' + eventType;
          } else {
            name = `${eventType}${rank}`;
          }
          minute = rank;
      }
    } else if (this.match.sport === 'ski_jump') {
      name = `${eventType}${rank}`;
      minute = rank;
    } else if (this.match.sport === 'alpine') {
      switch (type) {
        case 'sprint':
          if (rank < 7) {
            name = `${eventType}${rank}`;
          } else if (rank < 11) {
            name = 'prolog_top10';
          } else if (rank < 21) {
            name = 'prolog_top20';
          } else {
            name = 'prolog_top30';
          }
          minute = rank;
          break;
        case 'combined':
          if (rank > 29 && !/downhill|slalom/.test(eventType)) {
            name = 'finished' + ' ' + eventType;
          } else if (rank > 19 && !/downhill|slalom/.test(eventType)) {
            name = 'top29' + ' ' + eventType;
          } else {
            name = `${eventType}${rank}`;
          }
          minute = rank;
          break;
        default:
          if (rank > 29 && !/split/.test(eventType)) {
            name = 'finished' + ' ' + eventType;
          } else if (rank > 19 && !/split/.test(eventType)) {
            name = 'top29' + ' ' + eventType;
          } else {
            name = `${eventType}${rank}`;
          }
          minute = rank;
      }
    } else if (this.match.sport === 'biathlon') {
      if (rank > 29 && !/split|relay|shooting|single_mixed/.test(eventType)) {
        name = 'finished' + ' ' + eventType;
        minute = rank;
      } else if (
        rank > 19 &&
        !/split|relay|shooting|single_mixed/.test(eventType)
      ) {
        name = 'top29' + ' ' + eventType;
        minute = rank;
      } else if (['shooting_relay', 'shooting_other'].includes(eventType)) {
        name = eventType;
        minute = this.hits == null ? 5 : this.hits;
      } else {
        name = `${eventType}${rank}`;
        minute = rank;
      }
    } else if (this.match.sport === 'formula_one') {
      if (eventType === 'starting_rank') {
        name = 'starting_rank';
      } else if (rank <= 22) {
        name = 'rank' + rank;
      } else {
        name = 'finished';
      }
    } else {
      const type = this.match.matchType === 'v75' ? '_major' : '';
      if (rank < 4) {
        name = 'rank' + rank + type;
      } else {
        name = 'finished' + type;
      }
    }
    const event = {
      second: 0,
      minute: minute,
      name: name,
      match: this.match._id,
      team: lineup.team._id,
      player: lineup.player._id,
    };
    if (eventType === 'ping') {
      delete event.player;
      delete event.team;
    }
    this.match
      .post('events', {
        event: event,
        skipCalculations: true,
      })
      .catch((err) => console.error(err))
      .then(({ event: createdEvent }) => {
        this.events.push(Event.instance(createdEvent._id, event));
        this.isSubmittingRank = false;
        lineup.$isSubmitting = false;
        this.render();
      });
    this.render();
  }

  async destroyAllEvents(eventsByName, noPrompt) {
    this.isSubmittingRank = true;
    if (!noPrompt) {
      const answer = await prompt(
        `
          This will attempt to delete all events belonging to this match.
          Please write "I know what I'm doing" to continue.
        `,
        {
          level: 'warning',
        },
      ).catch(() => '');

      if (answer.toLowerCase() !== "i know what i'm doing") {
        if (answer.length)
          prompt('Confirmation text was not correct', {
            level: 'danger',
            type: 'ok',
          });
        return;
      }
    }

    this.match
      .post('destroy-all-events', { eventsByName })
      .then(() => {
        Match.clearHTTPCache();
        Event.clearHTTPCache();
        this.match.load();
        this.state.reload();
        this.isSubmittingRank = false;
        this.render();
      })
      .catch((error) => {
        console.error(error);
        this.render();
      });
    this.render();
  }

  toggleSelected(event) {
    event.selected = !event.selected;
    this.render();
    setTimeout(() => this.render(), 200);
  }

  async destroySelectedEvents(selectedEvents) {
    var eventsByName = [];
    for (const event of selectedEvents) {
      if (!event.selected || event?.name.split('_')[0] === 'match') continue;
      else {
        this.render();
        eventsByName.push(event);
      }
    }
    if (eventsByName.length === 0) {
      await prompt('No events selected', { level: 'danger', type: 'ok' });
      return;
    }
    this.destroyAllEvents(eventsByName);
  }

  destroy(event) {
    if (this.isSubmittingRank) return;
    this.isSubmittingRank = true;
    event.$isSubmitting = true;
    this.match
      .post('pull-event', { eventId: event._id })
      .then(() => {
        this.state.reload();
        this.isSubmittingRank = false;
        this.render();
      })
      .catch(() => {
        event.$isSubmitting = false;
        this.isSubmittingRank = false;
        this.render();
      });
  }

  isResult(event) {
    return (
      event.name === 'finished' ||
      !event.name.indexOf('top') ||
      ~event.name.indexOf('rank') ||
      ~event.name.indexOf('Rank')
    );
  }

  eventName(event) {
    return eventNames[event];
  }

  eventClass(event) {
    if ((this.eventType || 'rank') === event) return 'selected';
  }

  isSelected(val) {
    if (this.hits === val) return 'selected';
  }
  selectEventType(event) {
    this.eventType = event;
  }

  changeReceiver(giver, lineup, val) {}
  get state() {
    return getState(this.match);
  }

  get nextPosition() {
    const attr =
      this.eventType && this.eventType.includes('_rank')
        ? camelCase(this.eventType)
        : camelCase(this.eventTypes[0]);
    if (/shooting/.test(this.eventType)) {
      return 1;
    }
    return (
      (this.lineups || [])
        .filter((l) => l.stats && l.stats[attr])
        .filter((l) => !this.batch || this.batch === (l.batch || l.stats.batch))
        .reduce((max, l) => Math.max(max, l.stats[attr]), 0) + 1
    );
  }

  get unranked() {
    if (this.hasJuryEvents) {
      const ret = [];
      if (!this.activeLineup)
        return (
          this.lineups && this.lineups.filter((l) => l.status === 'confirmed')
        );
      const events = this.match.events.filter(
        (z) => z.name && z.name.includes(this.activeLineup.lastName),
      );
      for (const lineup of this.lineups) {
        const lineupEvent = events.filter(
          (e) => e.playerId === lineup.playerId,
        );
        if (!lineupEvent.length && lineup.status === 'confirmed') {
          ret.push(lineup);
        }
      }
      return ret;
    }

    const search = (this.search || '')
      .split(/\s+|,/)
      .filter((part) => part)
      .map(normalize);
    const eventType = this.eventType || 'rank';
    const attr = camelCase(eventType);
    const isRank = rankTypes.includes(eventType);

    return (this.lineups || [])
      .filter((l) => l.status === 'confirmed')
      .filter((l) => {
        if (this.eventType === 'fastest_pit_stop') {
          return l.player.position === 'ctor';
        }
        return !~unrankable.indexOf(l.player.position);
      })
      .filter((l) => {
        if (!isRank) return true;
        if (['shooting_other', 'shooting_relay'].includes(eventType))
          return true;
        if (this.batch && this.batch !== (l.batch || l.stats.batch))
          return false;
        if (l.stats && l.stats[attr]) return false;
        if (l.stats && l.stats.forfeit) return false;
        return true;
      })
      .filter((l) => {
        if (!search.length) return true;
        const searched = [
          l.player.firstName,
          l.player.lastName,
          l.player.customName,
          l.team && l.team.name,
          l.team && l.team.abbr,
        ]
          .filter((part) => part)
          .map(normalize)
          .join('|');
        for (const part of search) {
          if (~searched.indexOf(part)) return true;
        }
      })
      .sort((a, b) => a.player.name.localeCompare(b.player.name));
  }

  get eventTypes() {
    const { sport, matchType } = this.match;
    let category;
    if (matchType === 'normal') {
      category = sport;
    } else if (/\b(stage)\b/.test(this.match.tag)) {
      category = sport + '_' + matchType + '_' + 'stage';
    } else {
      category = sport + '_' + matchType;
    }
    if (!matchType) {
      category = sport;
    }
    return eventTypes[category] || ['rank', 'split_rank'];
  }
  get nameSortedEvents() {
    const eventsByName = [];
    if (!this.events) return;
    const eventTypes = this.eventTypes.concat('match_started', 'match_ended');
    for (const eventType of eventTypes) {
      if (
        !['match_started', 'match_ended'].includes(eventType) &&
        this.eventType &&
        this.eventType !== eventType
      )
        continue;

      const events = this.events || [];
      let filteredEvents = [];
      if (eventType === 'rank') {
        filteredEvents = events
          .filter((e) => {
            if (!e.name || e.name === 'starting_rank') return false;

            return (
              (e.name.indexOf(eventType) !== -1 &&
                e.name.indexOf('split') === -1) ||
              e.name.indexOf('top') === 0 ||
              e.name === 'finished'
            );
          })
          .sort((a, b) => b.minute - a.minute);
      } else {
        filteredEvents = events.filter((e) => e.name === eventType);
      }

      eventsByName.push(filteredEvents);
    }
    return eventsByName.filter((arr) => arr.length);
  }

  get unrankable() {
    return unrankable;
  }

  batched(batch) {
    return (
      (this.lineups && this.lineups.filter((l) => l.batch === batch)) || []
    );
  }

  showPos(match, pos) {
    if (!match.isRacing) return false;
    if (/\b(prolog|semi|quarter|stage)\b/.test(match.tag)) return false;
    return match.rules.positions().includes(pos);
  }

  posTitle(pos) {
    return pos.charAt(0).toUpperCase() + pos.slice(1) + 's';
  }
  concatEvents(allEvents) {
    var arr = [];
    for (const events of allEvents) {
      for (const singleEvent of events) {
        arr.push(singleEvent);
      }
    }
    return arr;
  }
}
